const plugin = require('tailwindcss/plugin');

module.exports = {
  corePlugins: {
    container: false,
    aspectRatio: false
  },
  purge: {
    enabled: false, // TODO enable it before commit
    // enabled: true,
    content: ['./src/**/*.js'],
    options: {
      safelist: [/grid-/]
    }
  },
  important: true,

  theme: {
    fontFamily: {
      primary: ['proxima-nova'],
      secondary: ['roboto']
    },
    screens: {
      xs: '400px',
      sm: '640px',
      md: '768px',
      md2: '800px',
      lg: '1024px',
      lg2: '1280px',
      xl: '1476px',
      xl2: '1800px',
      xl3: '2500px'
    },
    extend: {
      colors: {
        primary: '#1b1b1b',
        secondary: '#f30e04',
        'secondary-two': '#212121',
        'secondary-three': '#696969',
        'secondary-four': '#e5e5e5',
        'secondary-five': '#f8f8f8',
        'secondary-six': '#c80E04',
        tertiary: '#1C8987',
        success: '#009E06'
      },
      zIndex: {
        '-1': -1,
        600: 600,
        700: 700
      },
      fontSize: {
        10: '10px',
        12: '12px',
        14: '14px',
        15: '15px',
        18: '18px',
        16: '16px',
        20: '20px',
        22: '22px',
        24: '24px',
        28: '28px',
        30: '30px',
        32: '32px',
        36: '36px',
        40: '40px'
      },
      spacing: {
        13: '3.25rem',
        15: '3.75rem',
        18: '4.5rem',
        '420px': '420px',
        '480px': '480px',
        '520px': '520px',
        '93perc': '93%',
        '98perc': '98%'
      },
      height: {
        '170px': '170px',
        '200px': '200px',
        '250px': '250px',
        '300px': '300px',
        '400px': '400px',
        '420px': '420px',
        '480px': '480px',
        '500px': '500px',
        '520px': '520px',
        '600px': '600px',
        '800px': '800px'
      },
      maxHeight: {
        '170px': '170px',
        '200px': '200px',
        '250px': '250px',
        '300px': '300px',
        '400px': '400px',
        '420px': '420px',
        '480px': '480px',
        '500px': '500px',
        '520px': '520px',
        '600px': '600px',
        '800px': '800px'
      },
      maxWidth: {
        '170px': '170px',
        '200px': '200px',
        '250px': '250px',
        '300px': '300px',
        '400px': '400px',
        '420px': '420px',
        '480px': '480px',
        '500px': '500px',
        '520px': '520px',
        '600px': '600px',
        '800px': '800px'
      },

      minWidth: {
        '170px': '170px',
        '200px': '200px',
        '250px': '250px',
        '300px': '300px',
        '400px': '400px',
        '420px': '420px',
        '480px': '480px',
        '500px': '500px',
        '520px': '520px',
        '600px': '600px',
        '800px': '800px'
      }
    }
  },
  variants: {
    extend: {
      boxShadow: ['responsive']
    }
  },

  plugins: [
    require('@tailwindcss/aspect-ratio'),
    plugin(function ({ addUtilities, config }) {
      const headings = {
        h1: {
          fontFamily: `${config('theme.fontFamily.primary')} !important`,
          fontSize: '30px !important',
          fontWeight: '600 !important',
          lineHeight: '39px !important'
        },
        h2: {
          fontFamily: `${config('theme.fontFamily.primary')} !important`,
          fontSize: '28px !important',
          fontWeight: '600 !important',
          lineHeight: '36px !important'
        },
        h3: {
          fontFamily: `${config('theme.fontFamily.primary')} !important`,
          fontSize: '24px !important',
          fontWeight: '600 !important',
          lineHeight: '33px !important'
        },
        h4: {
          fontFamily: `${config('theme.fontFamily.primary')} !important`,
          fontSize: '20px !important',
          fontWeight: '600 !important',
          lineHeight: '28px !important'
        },
        h5: {
          fontFamily: `${config('theme.fontFamily.primary')} !important`,
          fontSize: '16px !important',
          fontWeight: '700 !important',
          lineHeight: '23px !important'
        },
        body: {
          fontFamily: `${config('theme.fontFamily.primary')} !important`,
          fontSize: '16px !important'
        }
      };
      addUtilities(headings);
    }),
    plugin(function ({ addUtilities, config }) {
      const containerUtilities = {
        '.container': {
          marginLeft: 'auto',
          marginRight: 'auto',
          width: '100%',
          maxWidth: `${config('theme.screens.xl2')}`
        }
      };
      addUtilities(containerUtilities);
    }),
    plugin(function ({ addUtilities, config }) {
      const selectboxUtilities = {
        '.delorge-select__control': {
          color: config('theme.colors.primary'),
          border: `1px solid ${config('theme.colors.secondary-three')}`,
          borderRadius: 4,
          paddingLeft: 10,
          paddingRight: 10,
          paddingTop: 5,
          paddingBottom: 5,
          outline: 'none',
          boxShadow: 'none'
        },

        '.error .delorge-select__control ': {
          borderColor: 'rgba(239, 68, 68, 1)'
        },
        '.account-gender .delorge-select__control': {
          padding: '0.5rem 1.25rem'
        },

        '.language-select .delorge-select__control': {
          border: `1px solid ${config('theme.colors.secondary-four')}`
        },
        '.delorge-select__control--is-disabled': {
          opacity: 0.5
        },
        '.delorge-select__placeholder': {
          paddingRight: 0,
          paddingLeft: 0
        },
        '.delorge-select__value-container': {
          paddingRight: 0,
          paddingLeft: 0
        },
        '.delorge-select__input': {
          outlineStyle: 'solid',
          outlineWidth: 2,
          outlineColor: 'transparent',
          outlineOffset: 2
        },
        '.delorge-select__option': {
          color: config('theme.colors.primary')
        },
        '.delorge-select__option:hover': {
          color: `${config('theme.colors.primary')}`,
          backgroundColor: `${config('theme.colors.secondary-five')}`,
          cursor: 'pointer'
        },
        '.delorge-select__option--is-focused': {
          color: `${config('theme.colors.primary')}`,
          backgroundColor: `${config('theme.colors.secondary-five')}`
        },
        '.delorge-select__option--is-selected': {
          color: `${config('theme.colors.primary')}`,
          backgroundColor: `${config('theme.colors.secondary-five')}`
        },
        '.no-right-rounded .delorge-select__control': {
          borderBottomLeftRadius: 4,
          borderTopLeftRadius: 4,
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0
        },
        '.no-left-rounded .delorge-select__control': {
          borderBottomLeftRadius: 0,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 4,
          borderBottomRightRadius: 4
        },
        '.no-right-border .delorge-select__control': {
          borderRight: 0
        },
        '.no-left-border .delorge-select__control': {
          borderLeft: 0
        }
      };
      addUtilities(selectboxUtilities);
    }),
    plugin(function ({ addUtilities, config }) {
      const buttonUtilities = {
        '.button': {
          fontWeight: 600,
          borderRadius: '0.25rem',
          paddingLeft: '1.25rem',
          paddingRight: '1.25rem',
          paddingTop: '0.5rem',
          paddingBottom: '0.5rem',
          cursor: 'pointer',
          transition: 'background-color 150ms'
        },
        '.button-primary': {
          color: '#ffffff',
          backgroundColor: config('theme.colors.secondary')
        },
        '.button-primary:hover': {
          backgroundColor: '#C80E04'
        },
        '.button-secondary': {
          color: '#ffffff',
          backgroundColor: config('theme.colors.secondary-two')
        },
        '.button-secondary:hover': {
          backgroundColor: config('theme.colors.secondary-three')
        },
        '.button-alternate': {
          color: config('theme.colors.primary'),
          backgroundColor: config('theme.colors.secondary-five')
        },
        '.button-alternate:hover': {
          backgroundColor: config('theme.colors.secondary-four')
        }
      };
      addUtilities(buttonUtilities);
    }),
    plugin(function ({ addUtilities }) {
      const pixelUtilities = {
        '.h-2px': {
          height: '2px'
        },
        '.h-90px': {
          height: '90px'
        },
        '.h-64px': {
          height: '64px'
        },
        '.h-650px': {
          height: '650px'
        },
        '.h-800px': {
          height: '800px'
        },
        '.w-150px': {
          width: '150px'
        },
        '.w-200px': {
          width: '200px'
        },
        '.w-250px': {
          width: '250px'
        },
        '.w-480px': {
          width: '480px'
        },
        '.pl-40px': {
          paddingLeft: '40px'
        },
        '.pb-76px': {
          paddingBottom: '76px'
        }
      };
      addUtilities(pixelUtilities, ['responsive']);
    }),
    plugin(function ({ addUtilities }) {
      const calcUtilities = {
        '.w-half-minus-1-rem': {
          width: 'calc(50% - 1rem)'
        },
        '.w-third-minus-1-rem': {
          width: 'calc(33% - 1rem)'
        },
        '.w-quarter-minus-1-rem': {
          width: 'calc(25% - 1rem)'
        },
        '.min-h-content-desktop': {
          minHeight: 'calc(100vh - 472px)'
        }
      };
      addUtilities(calcUtilities, ['responsive']);
    }),
    plugin(function ({ addUtilities }) {
      const recaptchaUtilities = {
        '.grecaptcha-badge': {
          visibility: 'hidden'
        }
      };
      addUtilities(recaptchaUtilities, ['responsive']);
    })
  ]
};
